import { createContext, useContext } from 'react';

export interface DirectConnectNetworkInfo {
  ssid?: string;
  ipAddress?: string;
  gateway?: string;
}

export interface DirectConnectNetworkDisconnectOptions {
  disableGateError?: boolean;
}

export interface DirectConnectNetworkContextValue {
  networkInfo?: DirectConnectNetworkInfo;
  hasError?: boolean;
  disconnectNetwork: (
    options?: DirectConnectNetworkDisconnectOptions
  ) => Promise<boolean>;
}

const DirectConnectNetworkContext = createContext<
  DirectConnectNetworkContextValue | undefined
>(undefined);

const useDirectConnectNetworkContext = (): DirectConnectNetworkContextValue => {
  return useContext(
    DirectConnectNetworkContext
  ) as DirectConnectNetworkContextValue;
};

export { useDirectConnectNetworkContext, DirectConnectNetworkContext };
